// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d4e5eb04","513":"2eb633bd"}[chunkId] + ".chunk.js";
};